export const UPDATE_FILTERS = "UPDATE_FILTERS";
export const UPDATE_CALENDERDATA = "UPDATE_CALENDERDATA";
export const AFTER_LOGIN_TRIGGER_PAGE = "AFTER_LOGIN_TRIGGER_PAGE";
export const AFTER_PLACEBID_TRIGGER_PAGE = "AFTER_PLACEBID_TRIGGER_PAGE";
export const AFTER_REGISTERBID_TRIGGER_PAGE = "AFTER_REGISTERBID_TRIGGER_PAGE";
export const TRIGGER_LOGIN_POPUP = "TRIGGER_LOGIN_POPUP";
